/*
 * Renzo Pagani CRO preview.
 * Loaded only by the unpublished Shopify draft theme.
 */
(() => {
  const preferredNames = {
  "renzo-pagani-velocite": "Aéroligne Chronograph",
  "renzo-pagani-magnolia": "Émeraude 32",
  "renzo-pagani-regent": "Océanique Planétaire 42",
  "renzo-pagani-souverain": "Orbital Skeleton",
  "renzo-pagani-circuit": "Octave Offshore Chronograph",
  "renzo-pagani-vendome": "Patrimoine Sport Chronograph",
  "renzo-pagani-beaubourg": "Nautique Chronograph",
  "renzo-pagani-concorde": "Rive Gauche Small Seconds",
  "renzo-pagani-palatin": "Héritage Diver 40",
  "renzo-pagani-brasier": "Héritage Racing Chronograph",
  "renzo-pagani-voyageur": "Céleste Dual Time",
  "renzo-pagani-belvedere": "Alpine Diver 43",
  "renzo-pagani-diademe": "Orbital Twin Tourbillon",
  "renzo-pagani-monarque": "Mécanique Twin Balance",
  "renzo-pagani-piston": "Aviateur Chronograph 44",
  "renzo-pagani-sorbonne": "Vélocité Ceramic Chronograph 40",
  "renzo-pagani-noblesse": "Atelier Automatic 40",
  "renzo-pagani-rotonde": "Lusitano Chronograph 41",
  "renzo-pagani-capitole": "Astrale Complication",
  "renzo-pagani-montparnasse": "Atelier Texturé Automatic 40",
  "renzo-pagani-florentine": "Vendôme Date 40",
  "renzo-pagani-tempete": "Lunaire Circuit Chronograph",
  "renzo-pagani-versailles": "Océanique Diver 300",
  "renzo-pagani-bellini": "Circuit Tonneau Chronograph",
  "renzo-pagani-lutece": "Avenue Automatic 37",
  "renzo-pagani-saphir-royale": "Atelier Square Automatic",
  "renzo-pagani-doge": "Nautique Open Heart 42",
  "renzo-pagani-prisma-course": "Vélocité Spectrum Chronograph",
  "renzo-pagani-etoile": "Chemin de Fer Automatic 38",
  "renzo-pagani-colonnade": "Couronnement Complete Calendar",
  "renzo-pagani-maesta": "Héritage Lagoon Diver 42",
  "renzo-pagani-sillage": "Vélocité Sport Chronograph",
  "renzo-pagani-carillon": "Balance Ouverte Automatic",
  "renzo-pagani-clementine": "Céleste Moonphase",
  "renzo-pagani-fulminant": "Mécanique Racing Chronograph",
  "renzo-pagani-aristide": "Mécanique Skeleton Automatic",
  "renzo-pagani-bourbon": "Vélocité Skeleton Automatic",
  "renzo-pagani-sacre": "Mécanique Tourbillon 40",
  "renzo-pagani-verdoyer": "Lunaire Heritage Chronograph",
  "renzo-pagani-palazzo": "Circuit Tonneau Skeleton",
  "renzo-pagani-abysse": "Vendôme Date 41",
  "renzo-pagani-maree": "Héritage Rivet Diver 40",
  "renzo-pagani-apogee": "Astrale Open Heart",
  "renzo-pagani-fuseau": "Expédition GMT 39",
  "renzo-pagani-apex": "Lusitano Régulateur Chronograph",
  "renzo-pagani-saphira": "Vendôme Joaillerie Chronograph",
  "renzo-pagani-cadence": "Aviateur Chronograph 38",
  "renzo-pagani-solferino": "Patrimoine Date 40",
  "renzo-pagani-citadelle": "Patrimoine Automatic 43",
  "renzo-pagani-emeraude": "Nautique Moonphase",
  "renzo-pagani-boreal": "Cartographe World Time GMT",
  "renzo-pagani-medicis": "Héritage Small Seconds",
  "renzo-pagani-aragon": "Songe Lunaire Automatic",
  "renzo-pagani-pavillon": "Grande Seconde 40",
  "renzo-pagani-brasero": "Circuit Glassbox Chronograph",
  "renzo-pagani-fougue": "Héritage Seventies Chronograph",
  "renzo-pagani-sprint": "Lusitano Textile Chronograph",
  "renzo-pagani-trajectoire": "Trajectoire Chronograph",
  "renzo-pagani-recif": "Cartographe GMT 40",
  "renzo-pagani-chatelet": "Couronnement Day-Date 40",
  "renzo-pagani-richelieu": "Patrimoine Sport Automatic",
  "renzo-pagani-turenne": "Vélocité Spectrum Chronograph 44",
  "renzo-pagani-lagon": "Pacifique Automatic 45",
  "renzo-pagani-diamantine": "Circuit Joaillerie Tonneau",
  "renzo-pagani-etincelle": "Circuit Tonneau Skeleton 39",
  "renzo-pagani-saint-honore": "Circuit Tonneau Skeleton 41",
  "renzo-pagani-regalia": "Héritage Rivet Diver 42",
  "renzo-pagani-tropique": "Expédition GMT 40",
  "renzo-pagani-couronne": "Régate Date 40",
  "renzo-pagani-tourmaline": "Aviateur Bicompax 38",
  "renzo-pagani-aurelio": "Octave Offshore Skeleton",
  "renzo-pagani-ondine": "Marina Automatic 41",
  "renzo-pagani-caspienne": "Horloger Diver Tourbillon",
  "renzo-pagani-bolide": "Grand Régulateur Chronograph 41",
  "renzo-pagani-sirene": "Nautique Tactical Diver",
  "renzo-pagani-adriano": "Orbital Diver Automatic",
  "renzo-pagani-galliera": "Régate Day-Date 40",
  "renzo-pagani-profond": "Éclat Sport Automatic 40",
  "renzo-pagani-triton": "Marina Skeleton Automatic",
  "renzo-pagani-esplanade": "Marée Diver 42",
  "renzo-pagani-noctis-course": "Vélocité Ceramic Chronograph",
  "renzo-pagani-dore-circuit": "Vélocité Prestige Chronograph",
  "renzo-pagani-granducale": "Circuit Tonneau Skeleton 42",
  "renzo-pagani-cordoban": "Marée Professional 42",
  "renzo-pagani-tachymetre": "Rive Gauche Chronograph",
  "renzo-pagani-vincennes": "Rive Gauche Automatic",
  "renzo-pagani-elan": "Héritage Panda Chronograph",
  "renzo-pagani-ressac": "Lusitano Bicompax 41",
  "renzo-pagani-seraphine": "Aviateur Classic 36",
  "renzo-pagani-corallo": "Océanique Heritage 300",
  "renzo-pagani-lavande": "Aviateur Heritage 38",
  "renzo-pagani-topaze": "Vélocité Tachymeter Chronograph",
  "renzo-pagani-capodimonte": "Éclat Sport 40",
  "renzo-pagani-marquise": "Nautique Automatic 40",
  "renzo-pagani-hortensia": "Couronnement Day-Date 36",
  "renzo-pagani-zenith": "Méridien World GMT",
  "renzo-pagani-cartographe": "Méridien Cartographe GMT",
  "renzo-pagani-orchidee": "Éclaireur Automatic 36",
  "renzo-pagani-mesange": "Éclat Automatic 36",
  "renzo-pagani-brindille": "Avenue Joaillerie",
  "renzo-pagani-nacre": "Vélocité Joaillerie Chronograph",
  "renzo-pagani-clarte": "Minimaliste 36",
  "renzo-pagani-frontenac": "Patrimoine Skeleton",
  "renzo-pagani-onda": "Patrimoine Small Seconds",
  "renzo-pagani-maestrale": "Océanique Diver 42",
  "renzo-pagani-imperial": "Héritage Rivet Automatic",
  "renzo-pagani-concertino": "Vélocité Skeleton Chronograph",
  "renzo-pagani-profondo": "Profondeur Date 40",
  "renzo-pagani-foudroyant": "Pacifique Chronograph 42",
  "renzo-pagani-cardinale": "Aviateur Automatic 44",
  "renzo-pagani-regina": "Terre & Mer Automatic",
  "renzo-pagani-laguna": "Marée Hydro Diver 42",
  "renzo-pagani-equateur": "Méridien GMT NH34",
  "renzo-pagani-meridienne": "Expédition GMT 42 Acier",
  "renzo-pagani-tramontane": "Héritage GMT",
  "renzo-pagani-avignon": "Océanique Planétaire 43",
  "renzo-pagani-allure": "Octave Chronograph",
  "renzo-pagani-gabbiano": "Marée Professional 43",
  "renzo-pagani-marenostro": "Aviateur Automatic 40",
  "renzo-pagani-zephyr-marin": "Aviateur Instrument 40",
  "renzo-pagani-sillon": "Méridien Left Crown GMT",
  "renzo-pagani-pole-position": "Lunaire Chronograph 42",
  "renzo-pagani-vitesse": "Vélocité Chronograph",
  "renzo-pagani-tresor": "Profondeur Bicolore 43",
  "renzo-pagani-mansart": "Profondeur Classic Date 40",
  "renzo-pagani-leviathan": "Pacifique Tool Automatic 45",
  "renzo-pagani-nereide": "Atelier Glacier Automatic 40",
  "renzo-pagani-cormoran": "Profondeur Deep Automatic 44",
  "renzo-pagani-mistral": "Méridien Crown GMT",
  "renzo-pagani-bathyale": "Éclat Automatic 40",
  "renzo-pagani-compteur": "Vélocité Panda Chronograph 40",
  "renzo-pagani-courant": "Aviateur Date Automatic 40",
  "renzo-pagani-rivage": "Aviateur Date 41",
  "renzo-pagani-or-royal": "Profondeur Bicolore Date 40",
  "renzo-pagani-transat": "Expédition GMT 42",
  "renzo-pagani-couronnement": "Octave Automatic",
  "renzo-pagani-murano": "Marée Aquatique 43",
  "renzo-pagani-sceau": "Vendôme Date 42",
  "renzo-pagani-asphalte": "Vélocité Panda Chronograph",
  "renzo-pagani-brandebourg": "Profondeur Classic 43",
  "renzo-pagani-verona": "Océanique Commander 42",
  "renzo-pagani-cavalier": "Régate Automatic 40",
  "renzo-pagani-horizon": "Méridien GMT"
};
  const modelCodes = {
  "renzo-pagani-velocite": "PD-1819",
  "renzo-pagani-magnolia": "PD-1825",
  "renzo-pagani-regent": "PD-YS034",
  "renzo-pagani-souverain": "PD-YS030",
  "renzo-pagani-circuit": "PD-YS032",
  "renzo-pagani-vendome": "PD-1780",
  "renzo-pagani-beaubourg": "PD-YS031",
  "renzo-pagani-concorde": "PD-YS029",
  "renzo-pagani-palatin": "PD-1821",
  "renzo-pagani-brasier": "PD-1822",
  "renzo-pagani-voyageur": "PD-1888",
  "renzo-pagani-belvedere": "PD-1820",
  "renzo-pagani-diademe": "PD-YS028",
  "renzo-pagani-monarque": "PD-YS022",
  "renzo-pagani-piston": "PD-1811",
  "renzo-pagani-sorbonne": "PD-1687",
  "renzo-pagani-noblesse": "PD-YS023",
  "renzo-pagani-rotonde": "PD-1772",
  "renzo-pagani-capitole": "PD-YS021",
  "renzo-pagani-montparnasse": "PD-1734",
  "renzo-pagani-florentine": "PD-YS027",
  "renzo-pagani-tempete": "PD-1816",
  "renzo-pagani-versailles": "PD-1818",
  "renzo-pagani-bellini": "PD-1725",
  "renzo-pagani-lutece": "PD-YS020",
  "renzo-pagani-saphir-royale": "PD-YS019",
  "renzo-pagani-doge": "PD-YS025",
  "renzo-pagani-prisma-course": "PD-1644-RAINBOW",
  "renzo-pagani-etoile": "PD-1793",
  "renzo-pagani-colonnade": "PD-1795",
  "renzo-pagani-maesta": "PD-1812",
  "renzo-pagani-sillage": "PD-1813",
  "renzo-pagani-carillon": "PD-1796",
  "renzo-pagani-clementine": "PD-1789",
  "renzo-pagani-fulminant": "PD-3307",
  "renzo-pagani-aristide": "PD-1791",
  "renzo-pagani-bourbon": "PD-1777",
  "renzo-pagani-sacre": "PD-YS017",
  "renzo-pagani-verdoyer": "PD-1701-GOLD-GREEN",
  "renzo-pagani-palazzo": "PD-YS018",
  "renzo-pagani-abysse": "PD-1691",
  "renzo-pagani-maree": "PD-1755",
  "renzo-pagani-apogee": "PD-YS015",
  "renzo-pagani-fuseau": "PD-1792-GMT",
  "renzo-pagani-apex": "PD-2720K",
  "renzo-pagani-saphira": "PD-1776",
  "renzo-pagani-cadence": "PD-1708",
  "renzo-pagani-solferino": "PD-1759",
  "renzo-pagani-citadelle": "PD-2770",
  "renzo-pagani-emeraude": "PD-1786",
  "renzo-pagani-boreal": "PD-1788-GMT-SEIKO-NH34",
  "renzo-pagani-medicis": "PD-1790",
  "renzo-pagani-aragon": "PD-YS014",
  "renzo-pagani-pavillon": "PD-1654",
  "renzo-pagani-brasero": "PD-1775",
  "renzo-pagani-fougue": "PD-1782",
  "renzo-pagani-sprint": "PD-1781",
  "renzo-pagani-trajectoire": "PD-1766",
  "renzo-pagani-recif": "PD-1784",
  "renzo-pagani-chatelet": "PD-1783",
  "renzo-pagani-richelieu": "PD-1778",
  "renzo-pagani-turenne": "PD-1732",
  "renzo-pagani-lagon": "PD-1697",
  "renzo-pagani-diamantine": "PD-YS013",
  "renzo-pagani-etincelle": "PD-YS011",
  "renzo-pagani-saint-honore": "PD-YS012",
  "renzo-pagani-regalia": "PD-1671-V2",
  "renzo-pagani-tropique": "PD-1762",
  "renzo-pagani-couronne": "PD-1651-ROSE-GOLD",
  "renzo-pagani-tourmaline": "PD-1773",
  "renzo-pagani-aurelio": "PD-YS010",
  "renzo-pagani-ondine": "PD-1767",
  "renzo-pagani-caspienne": "PD-1674",
  "renzo-pagani-bolide": "PD-YS008",
  "renzo-pagani-sirene": "PD-YN009",
  "renzo-pagani-adriano": "PD-YS007",
  "renzo-pagani-galliera": "PD-1726",
  "renzo-pagani-profond": "PD-1764",
  "renzo-pagani-triton": "PD-1736",
  "renzo-pagani-esplanade": "PD-1729",
  "renzo-pagani-noctis-course": "PD-1644-BLACK",
  "renzo-pagani-dore-circuit": "PD-1644-GOLD",
  "renzo-pagani-granducale": "PD-1738",
  "renzo-pagani-cordoban": "PD-1719",
  "renzo-pagani-tachymetre": "PD-1761",
  "renzo-pagani-vincennes": "PD-1753",
  "renzo-pagani-elan": "PAGANI-DESIGN-1718",
  "renzo-pagani-ressac": "PAGANI-DESIGN-1722",
  "renzo-pagani-seraphine": "PAGANI-DESIGN-1723",
  "renzo-pagani-corallo": "PAGANI-DESIGN-YS005",
  "renzo-pagani-lavande": "PAGANI-DESIGN-1717",
  "renzo-pagani-topaze": "PD-1727",
  "renzo-pagani-capodimonte": "PD-1733",
  "renzo-pagani-marquise": "PD-1728",
  "renzo-pagani-hortensia": "PD-1752",
  "renzo-pagani-zenith": "PD-1758-GMT-3",
  "renzo-pagani-cartographe": "PD-1758-GMT",
  "renzo-pagani-orchidee": "PD-1751",
  "renzo-pagani-mesange": "PD-1716",
  "renzo-pagani-brindille": "PD-1737",
  "renzo-pagani-nacre": "PD-1730",
  "renzo-pagani-clarte": "PD-1802L",
  "renzo-pagani-frontenac": "PD-1638",
  "renzo-pagani-onda": "PAGANI-DESIGN-1689",
  "renzo-pagani-maestrale": "PAGANI-DESIGN-1685",
  "renzo-pagani-imperial": "PAGANI-DESIGN-1671",
  "renzo-pagani-concertino": "PAGANI-DESIGN-1653",
  "renzo-pagani-profondo": "PAGANI-DESIGN-1694",
  "renzo-pagani-foudroyant": "PAGANI-DESIGN-1711",
  "renzo-pagani-cardinale": "PAGANI-DESIGN-1649",
  "renzo-pagani-regina": "PAGANI-DESIGN-1688",
  "renzo-pagani-laguna": "PAGANI-DESIGN-1702",
  "renzo-pagani-equateur": "PD-1662-NH34-GMT",
  "renzo-pagani-meridienne": "PD-1693",
  "renzo-pagani-tramontane": "PD-1706",
  "renzo-pagani-avignon": "PD-1679",
  "renzo-pagani-allure": "PD-1707",
  "renzo-pagani-gabbiano": "PD-1668A",
  "renzo-pagani-marenostro": "PD-1692-II",
  "renzo-pagani-zephyr-marin": "AIR-KING",
  "renzo-pagani-sillon": "PD-1662-GMT-I-BLACK-GREEN",
  "renzo-pagani-pole-position": "PAGANI-DESIGN-1701",
  "renzo-pagani-vitesse": "PD-1664",
  "renzo-pagani-tresor": "PD-1639-GOLD-BLUE",
  "renzo-pagani-mansart": "PD-1661",
  "renzo-pagani-leviathan": "PD-1695",
  "renzo-pagani-nereide": "PD-1715",
  "renzo-pagani-cormoran": "PD-1680",
  "renzo-pagani-mistral": "EXPLORER-GMT-PD-1662-ORO",
  "renzo-pagani-bathyale": "PD-1690",
  "renzo-pagani-compteur": "PD-1676",
  "renzo-pagani-courant": "PD-1692",
  "renzo-pagani-rivage": "PD-YS003",
  "renzo-pagani-or-royal": "1661",
  "renzo-pagani-transat": "PAGANI-DESIGN-GMT-2",
  "renzo-pagani-couronnement": "PAGANI-DESIGN-ROYAL-OAK",
  "renzo-pagani-murano": "PD-1668-AQUARACER",
  "renzo-pagani-sceau": "1645",
  "renzo-pagani-asphalte": "PD-1644",
  "renzo-pagani-brandebourg": "1639",
  "renzo-pagani-verona": "PAGANI-DESIGN-1667",
  "renzo-pagani-cavalier": "PD-1651",
  "renzo-pagani-horizon": "EXPLORERGMT"
};
  const topSellerHandles = [
  "renzo-pagani-horizon",
  "renzo-pagani-tropique",
  "renzo-pagani-pole-position",
  "renzo-pagani-equateur",
  "renzo-pagani-voyageur",
  "renzo-pagani-vitesse",
  "renzo-pagani-couronnement",
  "renzo-pagani-transat"
];

  function applyCollectionNames() {
    document.querySelectorAll("card-product[data-handle]").forEach((card) => {
      const handle = card.dataset.handle || "";
      const heading = card.querySelector(".card-product__title");
      if (!heading || !preferredNames[handle]) return;

      heading.textContent = preferredNames[handle];
      heading.dataset.lpPreview = "true";

      let code = card.querySelector(".rp-model-code");
      if (!code) {
        code = document.createElement("span");
        code.className = "rp-model-code";
        heading.insertAdjacentElement("afterend", code);
      }
      code.textContent = modelCodes[handle] || "";
    });
  }

  function applyHomepageNames() {
    document.querySelectorAll(".ap-product-card").forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const heading = card.querySelector(".ap-product-title");
      if (!link || !heading) return;

      const match = link.getAttribute("href")?.match(/\/products\/([^?#/]+)/);
      const handle = match?.[1] || "";
      if (!preferredNames[handle]) return;

      heading.textContent = preferredNames[handle];
      heading.dataset.lpPreview = "true";

      let code = card.querySelector(".rp-model-code");
      if (!code) {
        code = document.createElement("span");
        code.className = "rp-model-code";
        heading.insertAdjacentElement("afterend", code);
      }
      code.textContent = modelCodes[handle] || "";
    });
  }

  function enhanceTrustBanner() {
    const banner = document.querySelector(".vp-trust-bar");
    if (!banner || banner.classList.contains("rp-trust-banner")) return;

    const items = document.createElement("div");
    items.className = "rp-trust-items";
    ["Free Shipping", "2-Year Warranty", "30-Day Returns"].forEach((label) => {
      const item = document.createElement("span");
      item.className = "rp-trust-item";
      const icon = document.createElement("span");
      icon.className = "rp-trust-icon";
      icon.textContent = "✓";
      const text = document.createElement("span");
      text.textContent = label;
      item.append(icon, text);
      items.append(item);
    });

    banner.replaceChildren(items);
    banner.classList.add("rp-trust-banner");
  }

  function reorderTopSellers() {
    const grid = document.querySelector("#product-grid");
    if (!grid || !grid.querySelector(":scope > card-product")) return;

    const cards = [...grid.querySelectorAll(":scope > card-product")];
    const byHandle = new Map(cards.map((card) => [card.dataset.handle, card]));
    const promoted = topSellerHandles.map((handle) => byHandle.get(handle)).filter(Boolean);
    const promotedSet = new Set(promoted);
    grid.append(...promoted, ...cards.filter((card) => !promotedSet.has(card)));
  }

  function useCompactMobileHero() {
    if (!matchMedia("(max-width: 749px)").matches) return;
    const hero = document.querySelector('[id$="__hero_banner_NhWFPN"]');
    const desktop = hero?.querySelector(".hero__media.small-hide img");
    const mobile = hero?.querySelector(".hero__media.small-up-hide img");
    if (!desktop || !mobile) return;

    const desktopSource = desktop.getAttribute("src") || desktop.src;
    mobile.removeAttribute("srcset");
    mobile.removeAttribute("sizes");
    mobile.src = desktopSource.replace(/width=\d+/, "width=960");
  }

  function applyPreview() {
    useCompactMobileHero();
    reorderTopSellers();
    // Keep the native Shopify PD product titles.
    enhanceTrustBanner();
  }

  document.addEventListener("DOMContentLoaded", () => {
    applyPreview();
  });
})();
